import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { catchError, map, of } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const loginRedirect = router.createUrlTree(['/login']);

  return authService.verifyUserSimple('authGuard').pipe(
    map(isValid => (isValid ? true : loginRedirect))
  );
};

 
